const { query } = require('src/utils/query');

export const editTestimonialRequest = (payload) => {
  return query({
    uri: 'api/v1/admin/testimonials',
    method: 'PATCH',
    data: payload
  });
};
